<script>

import { createEventDispatcher } from 'svelte';
import { websiteCreate } from "../helper/PostHelper";

import {Input, Button} from '../components/ui';

export let productId; //TODO use store value if not set
export let model = {
    name: null,
    type: 0
};
const dispatch = createEventDispatcher();

async function save() {
    let data = await websiteCreate(productId, model);
    dispatch('save', data); //{id, data}
}
function cancel() {
   dispatch('cancel');
}

</script>

<div>

<div class="mb-4">
<Input bind:model={model.name} label="Name" />

</div>
<div class="flex flex-row">
<span class="flex-grow"></span>
<Button primary={true} on:submit={save}>Save</Button>
<Button on:submit={cancel}>Cancel</Button>
</div>

</div>